import React from "react";
import { ToggleButton, ToggleButtonGroup } from "@mui/material";
import { AnalyticsFilter } from "../../../types/analytics";

interface PeriodSelectorProps {
  filter: AnalyticsFilter;
  onChange: (filter: AnalyticsFilter) => void;
}

const periods = [
  { value: "7d", label: "7D" },
  { value: "30d", label: "30D" },
  { value: "90d", label: "90D" },
  { value: "6m", label: "6M" },
  { value: "1y", label: "1Y" },
] as const;

const PeriodSelector: React.FC<PeriodSelectorProps> = ({
  filter,
  onChange,
}) => {
  return (
    <ToggleButtonGroup
      value={filter.period}
      exclusive
      onChange={(_, value) => {
        if (value) {
          onChange({ ...filter, period: value });
        }
      }}
      size="small"
      sx={{
        "& .MuiToggleButton-root": {
          px: 2,
          py: 0.5,
          fontSize: "0.8rem",
          fontWeight: 600,
          textTransform: "none",
          "&.Mui-selected": {
            backgroundColor: "primary.main",
            color: "primary.contrastText",
            "&:hover": {
              backgroundColor: "primary.dark",
            },
          },
        },
      }}
    >
      {periods.map((p) => (
        <ToggleButton key={p.value} value={p.value}>
          {p.label}
        </ToggleButton>
      ))}
    </ToggleButtonGroup>
  );
};

export default PeriodSelector;
